<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask px-2 sm:px-4 sidebar:px-6 fixed pin w-full h-full flex justify-between items-center" @click="close" v-show="show">
        <div class="modal-container mx-auto flex flex-col rounded bg-white w-full shadow-lg" @click.stop>
            <slot></slot>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
  template: '#modal-template',
  props: {
    show: Boolean
  },
  methods: {
    close: function() {
      this.$emit('close');
    }
  },
  mounted: function() {
    document.addEventListener('keydown', e => {
      if (this.show && e.keyCode == 27) this.close();
    });
  }
};
</script>
